var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4487 3.95162L14.0487 7.55162M1.44873 16.5516L5.81472 15.6719C6.04649 15.6252 6.25931 15.5111 6.42645 15.3438L16.2001 5.5648C16.6687 5.09594 16.6684 4.33595 16.1994 3.86749L14.129 1.79942C13.6602 1.33115 12.9006 1.33147 12.4322 1.80013L2.65749 11.5802C2.49068 11.7471 2.37678 11.9595 2.33003 12.1908L1.44873 16.5516Z",
    stroke: "#1966FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.419ce4a721ae1f7879e8f23710329c2b.svg";
export { ForwardRef as ReactComponent };